export default __webpack_public_path__ + "static/media/report.2c373c4e.png";